import { UseBoundStore } from "zustand";
import type { Mutate, StoreApi } from "zustand/vanilla";

const storeResetFns: Set<UseBoundStore<any>> = new Set<UseBoundStore<any>>();

export const resetAllStores = () => {
  storeResetFns.forEach((store: UseBoundStore<Mutate<StoreApi<any>, any>>) => {
    store.setState(store.getInitialState());
  });
};

export const registerStore = (store: UseBoundStore<any>) => {
  storeResetFns.add(store);
};
